import { render, staticRenderFns } from "./aboutbw_honor.vue?vue&type=template&id=04918853&scoped=true&"
import script from "./aboutbw_honor.vue?vue&type=script&lang=js&"
export * from "./aboutbw_honor.vue?vue&type=script&lang=js&"
import style0 from "./aboutbw_honor.vue?vue&type=style&index=0&id=04918853&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04918853",
  null
  
)

export default component.exports